var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { class: _vm.$style.currentOrderItem, attrs: { xs12: "" } },
    [
      _c(
        "div",
        { class: _vm.$style.orderItemTitle },
        [
          _c("div", { class: _vm.$style.orderItemName }, [
            _c("h6", [_vm._v(_vm._s(_vm.name))]),
            _vm._v(" "),
            !_vm.disabled
              ? _c(
                  "a",
                  { class: _vm.$style.editBtn, on: { click: _vm.handleEdit } },
                  [
                    _c("svg", {
                      directives: [{ name: "svg", rawName: "v-svg" }],
                      class: _vm.$style.editIcon,
                      attrs: { symbol: "edit-icon" }
                    })
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("QuantityPicker", {
            attrs: { quantity: _vm.quantity, disabled: _vm.disabled },
            on: { "change-quantity": _vm.handleChangeQuantity }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { class: _vm.$style.orderItemDescription }, [
        _c("span", [_vm._v(_vm._s(_vm.stringifyItems(_vm.items)))])
      ]),
      _vm._v(" "),
      _vm.bossBundle && _vm.doesOrderIncludeBundle(_vm.orderItem.data)
        ? _c(
            "div",
            { class: _vm.$style.orderItemBundle },
            [
              _vm.doesOrderIncludePartialBundle(_vm.orderItem.data)
                ? [
                    _c("div", { class: _vm.$style.orderItemName }, [
                      _c("h6", [_vm._v("Fries")])
                    ]),
                    _vm._v(" "),
                    _c("div", { class: _vm.$style.orderItemDescription }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.stringifyItems(_vm.bundleItems)) +
                          "\n      "
                      )
                    ])
                  ]
                : [
                    _c("div", { class: _vm.$style.orderItemName }, [
                      _c("h6", [_vm._v(_vm._s(_vm.bossBundle.name))])
                    ]),
                    _vm._v(" "),
                    _c("div", { class: _vm.$style.orderItemDescription }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.stringifyItems(_vm.bundleItems)))
                      ])
                    ])
                  ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isOrderItemIncompleted
        ? _c(
            "p",
            { class: _vm.$style.incompleteItemBadge },
            [
              _c("v-icon", { attrs: { color: "orange" } }, [
                _vm._v("error_outline")
              ]),
              _vm._v("\n    Configuration is not completed\n  ")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: _vm.$style.orderItemTotal }, [
        _c("h6", [_vm._v("Item Total")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm._f("toPrice")(_vm.price)))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/cart/components/CartProduct.vue?vue&type=template&id=26ace7a1&
// module id = null
// module chunks = 